import React from 'react'
import { useTranslation } from 'react-i18next'
import { BrasilFlag, EuaFlag } from '../../assets'
import Flag from './Flag'

const I18n = () => {
    const { i18n } = useTranslation()

    function handleChangeLanguage(language) {
        i18n.changeLanguage(language)
    }

    const selectedLanguage = i18n.language // Idioma selecionado
    return (
        <div className="flags-container flex space-x-8">
            <Flag
                image={BrasilFlag}
                isSelected={selectedLanguage === 'pt-BR'}
                onClick={() => handleChangeLanguage('pt-BR')}
                width={'20px'}
            />
            <Flag
                image={EuaFlag}
                isSelected={selectedLanguage === 'en-US'}
                onClick={() => handleChangeLanguage('en-US')}
                width={'20px'}
            />
        </div>
    )
}

export default I18n
